// Updated Dashboard.jsx
import React, { useEffect, useState } from 'react';
import { LoginForm } from '../components/dashboard/LoginForm';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { checkAuth } from '../utils/api';
import { useLanguage } from '../store/languageContext';

const Dashboard = () => {
    const [loggedIn, setLoggedIn] = useState(false);
    const navigate = useNavigate();
    const { setNavColor } = useLanguage();

    useEffect(() => {
        checkAuth().then(res => {
            if (res.data.loggedIn) {
                setLoggedIn(true);
            } else {
                setLoggedIn(false);
            }
        });
        setNavColor('black');
    }, [navigate, setNavColor]);

    if (!loggedIn) return <LoginForm />;

    return (
        <div className="flex h-screen bg-gray-100 z-[1001] relative">
            {/* Sidebar */}
            <aside className="w-64 bg-white shadow-lg">
                <div className="p-4 pt-[44px]">
                    <h2 className="text-xl font-bold mb-6">Dashboard</h2>
                    <nav>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/dashboard/products" className="block py-2 px-4 text-gray-700 hover:bg-gray-200 rounded">Products</Link>
                            </li>
                            <li>
                                <Link to="/dashboard/brands" className="block py-2 px-4 text-gray-700 hover:bg-gray-200 rounded">Brands</Link>
                            </li>
                            <li>
                                <Link to="/dashboard/contact-requests" className="block py-2 px-4 text-gray-700 hover:bg-gray-200 rounded">Contact Requests</Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </aside>
            {/* Main Content */}
            <main className="flex-1 p-8 pt-[20px] overflow-auto">
                <Outlet />
            </main>
        </div>
    );
};

export default Dashboard;